import type { JSONContent } from "@tiptap/core";
import type { FC, ReactNode } from "react";
import { ActivityCommentItemDisplay } from "./activity-comment-item-display";
import { ActivityCommentItemEditing } from "./activity-comment-item-editing";

export type ActivityCommentItemProps = {
  id: string;
  content: JSONContent;
  isEditing?: boolean;
  isBeingEdited?: boolean;

  alertContentWrapper?: ReactNode;

  onEdit?: () => void;
  onCancel?: (anchor: HTMLElement) => void;
  onValidate?: () => void;
  onDelete?: (id: string, anchor: HTMLElement) => void;
  onContentChange?: (content: unknown) => void;
};

const ActivityCommentItem: FC<ActivityCommentItemProps> = ({
  id,
  isEditing,
  isBeingEdited,
  content,
  onContentChange,
}) => {
  return (
    <div className="flex flex-col space-y-4" id={`comment-${id}`}>
      {/* Content area (either editor or read-only content) */}
      {isEditing && isBeingEdited && onContentChange ? (
        <ActivityCommentItemEditing
          content={content}
          onContentChange={onContentChange}
        />
      ) : (
        <ActivityCommentItemDisplay id={id} content={content} />
      )}
    </div>
  );
};

export { ActivityCommentItem };
